//

//
//

import React, { Component } from "react";

export default function OfficeLoaction() {
	return (
		<div className="contact-bottom-section">
			<div className="contact-card">
				<div className="contact-image">
					<img
						alt=""
						src="https://feingeist-beratung.de/wp-content/uploads/2024/02/berlin_photo.webp"
					/>
				</div>
				<div className="contact-address">
					<h3 className="name py-2">Berlin</h3>
					<div className="contact-details">
						<p>Linkstraße 2 | Level 8 | 10785 Berlin</p>
						<div className="phone pb-2">
							<svg
								xmlns="https://www.w3.org/2000/svg"
								width="20"
								height="20"
								fill="black"
								className="bi bi-telephone"
								viewBox="0 0 16 16"
							>
								<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
							</svg>
							+49 (0) 30 700 127 060
						</div>
					</div>
				</div>
				<div className="contact-map">
					<iframe
						width="100%"
						height="150"
						src="https://www.openstreetmap.org/export/embed.html?bbox=13.364868164062502%2C52.50356605017116%2C13.384952545166017%2C52.51222500061098&amp;layer=mapnik&amp;marker=52.50789395110491%2C13.374903600000039"
					></iframe>
				</div>
			</div>
			<div className="contact-card">
				<div className="contact-image">
					<img
						alt=""
						src="https://feingeist-beratung.de/wp-content/uploads/2024/02/lz_photo_bw.webp"
					/>
				</div>

				<div className="contact-address">
					<h3 className="name py-2">Leipzig</h3>
					<div className="contact-details">
						<p>Thomasiusstraße 2 | 04109 Leipzig</p>
						<div className="phone">
							<svg
								xmlns="https://www.w3.org/2000/svg"
								width="20"
								height="20"
								fill="black"
								className="bi bi-telephone"
								viewBox="0 0 16 16"
							>
								<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
							</svg>
							+49 (0) 341 238 210 10
						</div>
					</div>
				</div>

				<div className="contact-map">
					<iframe
						width="100%"
						height="150"
						src="https://www.openstreetmap.org/export/embed.html?bbox=12.35416889190674%2C51.33825316352705%2C12.374253273010254%2C51.34746152047347&amp;layer=mapnik&amp;marker=51.34285757326163%2C12.36459732055664"
					></iframe>
				</div>
			</div>
		</div>
	);
}
